import React from "react"

const ProfileInfoItem = ({ icon, label, value }) => {
  return (
    <div className="d-flex align-items-start">
      <i className={`${icon} text-primary mt-1 me-2 fs-6`}></i>
      <div>
        <small className="text-muted d-block small">{label}</small>
        <span className="d-block">{value ?? "-"}</span>
      </div>
    </div>
  )
}

export default ProfileInfoItem
